var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.background,style:({
        backgroundImage:
            'radial-gradient(ellipse at ' + _vm.position.x + '%' + _vm.position.y + '%' + ', ' + _vm.color + ' 0%, #000 80%)',
    })})}
var staticRenderFns = []

export { render, staticRenderFns }